module.exports = __webpack_public_path__ + "static/media/3.16.329598c2.png";